import { twMerge } from 'tailwind-merge'

export const ValidFileNameRegex = /[<>:"/\\|?*]/g

export const getDraggerClassNames = (args: {
  asChild: boolean
  isInvalid: boolean
  isUploaded?: boolean
}) => {
  const { asChild, isInvalid, isUploaded } = args
  const asChildClassNames = '[&_.ant-upload]:!p-0 [&_.ant-upload]:!border-none'
  const defaultClassNames =
    'w-full [&_.ant-upload-list]:hidden [&_.ant-upload-drag]:!bg-white [&_.ant-upload-drag]:!border-neutral-200 [&_.ant-upload-drag]:!rounded-md [&_.ant-upload-btn]:!px-4 [&_.ant-upload-btn]:!py-2 [&_.ant-upload]:!p-0 [&_.ant-upload-btn]:!rounded-md'
  const invalidClassNames = '[&_.ant-upload-drag]:!border-red-500'
  const uploadedClassNames = '[&_.ant-upload-drag]:!border-solid'
  const interactiveClassNames =
    '[&_.ant-upload-drag]:hover:!border-sky-800 [&_.ant-upload-btn]:focus-visible:!outline [&_.ant-upload-btn]:focus-visible:!outline-outline'
  const dragOverClassNames =
    '[&_.ant-upload-drag.ant-upload-drag-hover]:!border-[rgb(250,84,28)] [&_.ant-upload-drag.ant-upload-drag-hover]:!border-dashed [&_.ant-upload-drag.ant-upload-drag-hover]:!bg-orange-50'
  return twMerge(
    ...(asChild
      ? [asChildClassNames]
      : [
          defaultClassNames,
          interactiveClassNames,
          dragOverClassNames,
          ...(isUploaded ? [uploadedClassNames] : []),
          ...(isInvalid ? [invalidClassNames] : []),
        ])
  )
}
